type Tab = 'log' | 'rescue' | 'history' | 'insights' | 'options';

type AppBottomNavProps = {
  tab: Tab;
  onChange: (tab: Tab) => void;
  labels: {
    log: string;
    rescue: string;
    history: string;
    insights: string;
    options: string;
  };
};

export function AppBottomNav({ tab, onChange, labels }: AppBottomNavProps) {
  return (
    <nav className="bottom-nav">
      <button className={tab === 'log' ? 'active' : ''} onClick={() => onChange('log')}>
        <span className="bottom-nav-kicker">Notice</span>
        {labels.log}
      </button>
      <button className={tab === 'rescue' ? 'active' : ''} onClick={() => onChange('rescue')}>
        <span className="bottom-nav-kicker">Support</span>
        {labels.rescue}
      </button>
      <button className={tab === 'history' ? 'active' : ''} onClick={() => onChange('history')}>
        <span className="bottom-nav-kicker">Remember</span>
        {labels.history}
      </button>
      <button className={tab === 'insights' ? 'active' : ''} onClick={() => onChange('insights')}>
        <span className="bottom-nav-kicker">Learn</span>
        {labels.insights}
      </button>
      <button className={tab === 'options' ? 'active' : ''} onClick={() => onChange('options')}>
        <span className="bottom-nav-kicker">Adjust</span>
        {labels.options}
      </button>
    </nav>
  );
}
